import React from "react";
import {
    ApnDetailsResponse,
    FinancePartnerDetailsResponse,
    JobPhotosResponse,
    NotesResponse,
    OpportunityInfoResponse,
    ProductDetailsResponse,
    StatusIndicatorsResponse,
    SystemDesignDetailsDirect,
    UtilityDetailsResponse,
} from "../../../../../services/oneButtonServices/opportunityValidationService";
import {StatusIndicators} from "./StatusIndicators";
import {Collapse} from "antd";
import {QuickLinks} from "./QuickLinks";
import {OpportunityInfo} from "./OpportunityInfo";
import {UtilityInfo} from "./UtilityInfo";
import {JobPhotos} from "./JobPhotos";
import {Notes} from "./Notes";
import {ProductFinanceMethods} from "./ProductFinanceMethods";
import {EquipmentDetails} from "./EquipmentDetails";

export interface OpportunityValidationCollapseProps {
    opportunityId: string;
    statusIndicators: StatusIndicatorsResponse;
    opportunity: OpportunityInfoResponse;
    financePartner: FinancePartnerDetailsResponse;
    apn: ApnDetailsResponse;
    product: ProductDetailsResponse;
    utility: UtilityDetailsResponse;
    photos: JobPhotosResponse;
    notes: NotesResponse;
    systemDesign: SystemDesignDetailsDirect[];
}

export const OpportunityValidationCollapse: React.FC<OpportunityValidationCollapseProps> = (props) => {

    const items = [
        {
            key: '1',
            label: 'Status Indicators',
            children: <StatusIndicators statusIndicators={props.statusIndicators}/>,
        },
        {
            key: '2',
            label: 'Opportunity Info',
            children: <OpportunityInfo
                opportunity={props.opportunity}
                financePartner={props.financePartner}
                apn={props.apn}/>,
        },
        {
            key: '3',
            label: 'Product / Finance Methods',
            children: <ProductFinanceMethods
                product={props.product}
                financePartner={props.financePartner}/>,
        },
        {
            key: '4',
            label: 'Utility Info',
            children: <UtilityInfo
                opportunityId={props.opportunityId}
                utility={props.utility}
                financePartner={props.financePartner}/>,
        },
        {
            key: '5',
            label: 'Job Photos',
            children: <JobPhotos photos={props.photos}/>,
        },
        {
            key: '6',
            label: 'Notes',
            children: <Notes notes={props.notes}/>,
        },
        {
            key: '7',
            label: 'Quick Links',
            children: <QuickLinks
                opportunity={props.opportunity}
                financePartner={props.financePartner}/>,
        },
        {
            key: '8',
            label: 'Equipment Details',
            children: <EquipmentDetails systemDesign={props.systemDesign}/>,
        },
    ];

    const defaultActiveKey = items.map(item => item.key);

    return (
        <Collapse
            items={items}
            defaultActiveKey={defaultActiveKey}/>
    );
};